import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { ApiUserCategoryType } from '@/modules/api';

import { CATEGORIES_SETUP } from '../../constants';
import { OnboardingParamsTool } from '../../utils/paramsTool';

import {
  PreferencesListV1ItemStyles,
  PreferencesListV1Styles,
} from './V1.styles';

export const PreferencesListV1: React.FC<{
  preloadCategories: ApiUserCategoryType[];
  categories: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
}> = ({ preloadCategories, categories, form }) => {
  return (
    <PreferencesListV1Styles>
      {preloadCategories &&
        preloadCategories.map((option) => {
          const selected = categories?.includes(option.id);
          const aiNumber =
            option.id in CATEGORIES_SETUP
              ? CATEGORIES_SETUP[option.id].number
              : 849;

          return (
            <PreferencesListV1ItemStyles
              key={option.id}
              imageSrc={option.background_picture?.v1 || ''}
              selected={selected}
              onClick={() => {
                const fieldValues = form.getValues('categories');

                const hasFormValue = fieldValues.includes(option.id);

                const copiedCategories = [...categories];

                if (hasFormValue) {
                  form.setValue(
                    'categories',
                    fieldValues.filter((x: string) => x !== option.id),
                  );
                  copiedCategories.splice(
                    copiedCategories.indexOf(option.id),
                    1,
                  );
                } else {
                  form.setValue('categories', [...fieldValues, option.id]);
                  copiedCategories.push(option.id);
                }

                OnboardingParamsTool.setParam('categories', copiedCategories);
              }}
            >
              <UiTypography variant="body-large">{option.title}</UiTypography>
              <UiTypography color="neutral-black" variant="body-medium">
                {aiNumber} AIs
              </UiTypography>
            </PreferencesListV1ItemStyles>
          );
        })}
    </PreferencesListV1Styles>
  );
};
